/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect } from "react";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { CarouselComponentEditWrapper } from "cms/components/components/hero-carousel/edit/component-carousel-wrapper";
import { HeroCarouselSlideEditor } from "cms/components/components/hero-carousel/edit/hero-carousel-slide-editor";
import { ErrorBoundary } from "react-error-boundary";
import { FieldErrorFallback } from "cms/fields/layout/field-error";

const HeroCarouselComponentEditor = () => {

    const { component, update } = useUpdateComponent();
    const slides = component?.slides;
    const content_position = component?.content_position ?? "left";
    // console.log('[onChangeList] original',slides)

    // Initialize content_position to "left" if it doesn't exist
    useEffect(() => {
        if (!component?.content_position) {
            update("content_position", "left");
        }
    }, [component?.content_position, update]);

    const onChangeContentPosition = (event) => {
        const position = event.target.value || "left";
        update("content_position", position);
    };

    const onChangeList = (slides) => {
        // console.log('[onChangeList] slides',slides)
        update("slides", slides);
    };

    return (
        <div className='simplicity-editor-frame'>
            <ErrorBoundary
                FallbackComponent={FieldErrorFallback}
                onReset={() => {
                    location.reload();
                }}
            >
                <CarouselComponentEditWrapper
                    slides={slides}
                    contentPosition={content_position}
                    onChangeContentPosition={onChangeContentPosition}
                    onChangeList={onChangeList}
                >

                    {/* Hero Carousel Slide */}
                    <HeroCarouselSlideEditor />

                </CarouselComponentEditWrapper>
            </ErrorBoundary>
        </div>
    );
};
HeroCarouselComponentEditor.displayName = "HeroCarouselComponentEditor";
export { HeroCarouselComponentEditor };
